import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import TruthQuestionCard from './TruthQuestionCard';
import DareQuestionCard from './DareQuestionCard';
import PopoverCard from './PopoverCard';
import { setMindfulnessAlertShown } from '../features/contestants/contestantsSlice';

const QuestionCard = ({ question, questionTimer, drinkQuestion, attributes, swapTurns, swapTurnsAndAddShot, swapSkippedTurns, truthOrDare, currentPlayer, playerOne, playerTwo, setPlayerAddShotAndSwap }) => {
  const dispatch = useDispatch();
  const [formattedTime, setFormattedTime] = useState("");
  const [mindfulnessOpen, setMindfulnessOpen] = useState(false);

  const mindfulnessAlertShown = useSelector((state) => state.contestants.mindfulnessAlertShown);
  const playerOneShots = useSelector((state) => {
    const p = state.contestants.playerOne;
    return (p.exploreShotsTaken || 0) + (p.comfortShotsTaken || 0) + (p.openShotsTaken || 0) + (p.demoShotsTaken || 0);
  });
  const playerTwoShots = useSelector((state) => {
    const p = state.contestants.playerTwo;
    return (p.exploreShotsTaken || 0) + (p.comfortShotsTaken || 0) + (p.openShotsTaken || 0) + (p.demoShotsTaken || 0);
  });

  useEffect(() => {
    if (!mindfulnessAlertShown && (playerOneShots >= 5 || playerTwoShots >= 5)) {
      dispatch(setMindfulnessAlertShown(true));
      setMindfulnessOpen(true);
    }
  }, [playerOneShots, playerTwoShots, mindfulnessAlertShown, dispatch]);

  const formatTime = (time) => {
    if (time < 90) {
      setFormattedTime(`${time} Sec`);
    } else {
      const minutes = Math.floor(time / 60);
      const seconds = time % 60;
      setFormattedTime(`${minutes}:${seconds.toString().padStart(2, '0')} Min`);
    }
  };

  useEffect(() => {
    formatTime(questionTimer);
  }, [questionTimer]);

  return (
    <>
      {truthOrDare === "Truth" ?
        <TruthQuestionCard
          question={question}
          formattedTime={formattedTime}
          questionTimer={questionTimer}
          attributes={attributes}
          swapTurns={swapTurns}
          swapTurnsAndAddShot={swapTurnsAndAddShot}
          swapSkippedTurns={swapSkippedTurns}
          setPlayerAddShotAndSwap={setPlayerAddShotAndSwap}
          currentPlayer={currentPlayer}
          playerOne={playerOne}
          playerTwo={playerTwo}
          typeOfDare={truthOrDare}
        />
        : <DareQuestionCard
          question={question}
          formattedTime={formattedTime}
          questionTimer={questionTimer}
          drinkQuestion={drinkQuestion}
          attributes={attributes}
          swapTurns={swapTurns}
          swapTurnsAndAddShot={swapTurnsAndAddShot}
          swapSkippedTurns={swapSkippedTurns}
          setPlayerAddShotAndSwap={setPlayerAddShotAndSwap}
          currentPlayer={currentPlayer}
          playerOne={playerOne}
          playerTwo={playerTwo}
          typeOfDare={truthOrDare}
        />
      }
      <PopoverCard
        open={mindfulnessOpen}
        onClose={() => setMindfulnessOpen(false)}
        mainText={"You've had 5 shots already! Remember, we use alcohol as a mindful tool — mind yourselves. You can always drink smaller shots, and at any point you can switch to Replay Mode (no alcohol) from the menu!"}
        showButtonOne={true}
        textButtonOne="I'll be mindful!"
        onButtonOne={() => setMindfulnessOpen(false)}
        hideBack={true}
      />
    </>
  );
};

export default QuestionCard;
